var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProcessingSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 33"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 1C7.163 1 0 8.163 0 17s7.163 16 16 16 16-7.163 16-16S24.837 1 16 1m0 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 23.627 4 17 9.373 5 16 5",
  opacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 1c8.837 0 16 7.163 16 16h-4c0-6.627-5.373-12-12-12z"
}))));
export default SvgProcessingSpinner;